import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { withConfig } from '../../Components/Context';
import { withI18n } from 'spa/Components/Context';
import moment from 'moment';

import Button, { ButtonSizeTypes, ButtonThemeTypes } from '@urbanmassage/component-library/lib/Button/Button';
import Divider from '@urbanmassage/component-library/lib/Divider/Divider';
import GiftsCheckout from './GiftsCheckout';
import GiftsHeader from './GiftsHeader';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

const GiftCardBuyStepThree = ({
  currentStep,
  deliveryOption,
  deliveryOptionLabel,
  edit,
  formatedAmount,
  giftMessage,
  gifts,
  giftType,
  giftUpgrade,
  recipient,
  selectedCity,
  session,
  setShowFooter,
  voucherValue,
}, { i18n, config }) => {
  const giftExpiry = config.getValue('feature.gift-voucher-expiry-months', i18n.umRegion);

  const handleEdit = (val) => {
    edit(val);
  };

  useEffect(() => {
    gifts.orderContent = {
      toEmail: recipient.email,
      toName: recipient.name,
      fromName: recipient.from,
      amount: voucherValue,
      message: giftMessage,
      type: deliveryOption === 'e-voucher' ? 'gift' : 'physical',
      sendAt: recipient.sendDay || null,
      addressStreet: recipient.address || '',
      addressCity: recipient.city || '',
      addressPostcode: recipient.postcode || '',
      city_id: selectedCity,
      paymentType: 'card',
      paymentNonce: '',
      expiresAt: moment().add(giftExpiry, 'months').format(gifts.DATE_FORMAT),
      isTreatmentVoucher: giftType === 'treatment',
    };
    gifts.giftDisplayText = giftMessage;
  }, [recipient, giftMessage, giftType, voucherValue, selectedCity, deliveryOption]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <GiftsHeader currentStep={currentStep} />
      <div className="gifts__review-header">
        <Typography variant={TypeVariants.h4} fontFamily="heading">
          {i18n._x('Select and personalise', 'Gifts page')}
        </Typography>
        <Button type="button" theme={ButtonThemeTypes.white} size={ButtonSizeTypes.small} onClick={() => handleEdit(1)}>
          {i18n._x('Edit', 'Gifts page')}
        </Button>
      </div>
      <Divider />
      <div className="gifts__review-content">
        <div className="gifts__review-details-lines">
          <span>
            <Typography variant={TypeVariants.body} bold>
              {i18n._x('Gift voucher value', 'Gifts page')}
            </Typography>
          </span>
          <Typography variant={TypeVariants.body}>
            {formatedAmount}
          </Typography>
        </div>
        <div className="gifts__review-details-lines">
          <span>
            <Typography variant={TypeVariants.body} bold>
              {i18n._x('Delivery option', 'Gifts page')}
            </Typography>
          </span>
          <Typography variant={TypeVariants.body}>
            {deliveryOptionLabel}
          </Typography>
        </div>
        <div className="gifts__review-details-lines">
          <span>
            <Typography variant={TypeVariants.body} bold>
              {i18n._x('Optional message', 'Gifts page')}
            </Typography>
          </span>
          <Typography variant={TypeVariants.body}>
            {giftMessage || '–'}
          </Typography>
        </div>
      </div>
      <div className="gifts__review-header">
        <Typography variant={TypeVariants.h4} fontFamily="heading">
          {i18n._x('Delivery details', 'Gifts page')}
        </Typography>
        <Button type="button" theme={ButtonThemeTypes.white} size={ButtonSizeTypes.small} onClick={() => handleEdit(2)}>
          {i18n._x('Edit', 'Gifts page')}
        </Button>
      </div>
      <Divider />
      <div className="gifts__review-content">
        <div className="gifts__review-details-lines">
          {deliveryOption === 'e-voucher' && recipient.email && (
            <React.Fragment>
              <span>
                <Typography variant={TypeVariants.body} bold>
                  {i18n._x('Recipient’s email', 'Gifts page')}
                </Typography>
              </span>
              <Typography variant={TypeVariants.body}>
                {recipient.email}
              </Typography>
            </React.Fragment>
          )}
          {deliveryOption !== 'e-voucher' && recipient.address && recipient.city && recipient.postcode && (
            <React.Fragment>
              <span>
                <Typography variant={TypeVariants.body} bold>
                  {i18n._x('Recipient’s address', 'Gifts page')}
                </Typography>
              </span>
              <Typography variant={TypeVariants.body}>
                {`${recipient.address}, ${recipient.city} ${recipient.postcode}`}
              </Typography>
            </React.Fragment>
          )}
        </div>
        <div className="gifts__review-details-lines">
          <span>
            <Typography variant={TypeVariants.body} bold>
              {i18n._x('Recipient’s name', 'Gifts page')}
            </Typography>
          </span>
          <Typography variant={TypeVariants.body}>
            {recipient.name}
          </Typography>
        </div>
        <div className="gifts__review-details-lines">
          <span>
            <Typography variant={TypeVariants.body} bold>
              {i18n._x('Your name', 'Gifts page')}
            </Typography>
          </span>
          <Typography variant={TypeVariants.body}>
            {recipient.from}
          </Typography>
        </div>
        <div className="gifts__review-details-lines">
          <span>
            <Typography variant={TypeVariants.body} bold>
              {i18n._x('Send date', 'Gifts page')}
            </Typography>
          </span>
          <Typography variant={TypeVariants.body}>
            {recipient.sendDay ? moment(recipient.sendDay).format('DD/MM/YYYY') : i18n._x('ASAP', 'Gifts page')}
          </Typography>
        </div>
      </div>
      <div className="gifts__review-header">
        <Typography variant={TypeVariants.h4} fontFamily="heading">
          {session && session.user ? i18n._x('Pay', 'Gifts page') : i18n._x('Sign in or register to complete your purchase', 'Gifts page')}
        </Typography>
      </div>
      <Divider />
      <div className="gifts__login-pay-section">
        <GiftsCheckout giftUpgrade={giftUpgrade} setShowFooter={setShowFooter} />
      </div>
    </div>
  );
};

GiftCardBuyStepThree.propTypes = {
  currentStep: PropTypes.number.isRequired,
  deliveryOption: PropTypes.string.isRequired,
  deliveryOptionLabel: PropTypes.string.isRequired,
  edit: PropTypes.func.isRequired,
  formatedAmount: PropTypes.string.isRequired,
  giftMessage: PropTypes.string,
  gifts: PropTypes.object.isRequired,
  giftType: PropTypes.string.isRequired,
  giftUpgrade: PropTypes.object,
  recipient: PropTypes.object.isRequired,
  selectedCity: PropTypes.string.isRequired,
  session: PropTypes.object.isRequired,
  setShowFooter: PropTypes.func.isRequired,
  voucherValue: PropTypes.string.isRequired,
};

export default inject(({
  store: {
    session,
    gifts,
  },
}) => ({
  session,
  gifts,
}))(withConfig((withI18n(GiftCardBuyStepThree))));



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCardBuyStepThree.jsx